import { ReactNode } from 'react';

import { ActionIcon, Box, Group, Title, Tooltip } from '@mantine/core';

interface CardProps {
  title?: string;
  children?: ReactNode;
  action?: {
    title: string;
    icon: ReactNode;
    onClick: () => void;
  };
}

export default function Card({ title, children, action }: CardProps) {
  // ==========================================================================
  // Render
  // ==========================================================================
  return (
    <Box>
      {title && (
        <Group wrap="nowrap" mb="lg" justify="space-between">
          <Title order={2}>{title}</Title>
          {action && (
            <Tooltip label={action.title}>
              <ActionIcon onClick={action.onClick}>{action.icon}</ActionIcon>
            </Tooltip>
          )}
        </Group>
      )}
      {children}
    </Box>
  );
}
